<template>
  <div class="input-container">
    <div class="grey lighten-5">
      <v-col v-if="permissions.includes('CAN_CREATE_ADMIN_USER')" cols="12" md="3">
        <v-btn class="btn btn-primary mr-4 mt-4" @click="openAdminUserModal('create')">Create</v-btn>
      </v-col>
      <loader v-if="showLoader"></loader>
      <v-col cols="12">
        <div class="table-div overflow-auto">
          <table class="table userlistTable small-table-width">
            <thead>
              <tr class="table-success">
                <th scope="col">Full Name</th>
                <th scope="col">Role</th>
                <!-- <th scope="col">Is Active</th> -->
                <th v-if="permissions.includes('CAN_EDIT_ADMIN_USER')" scope="col">Action</th>
                <th
                  v-if="permissions.includes('CAN_ACTIVE_DEACTIVE_ADMIN_USER')"
                  scope="col"
                >Is Active</th>
                <th
                  v-if="permissions.includes('CAN_REGENERATE_PASSWORD_ADMIN_USER')"
                  scope="col"
                >Regenerate Password</th>
              </tr>
            </thead>
            <tbody v-for="(item, index) in userList" :key="index">
              <tr>
                <td>
                  <div>{{`${item.first_name} ${item.last_name}`}}</div>
                </td>
                <td>
                  <div>{{item.user_role.name}}</div>
                </td>
                <td v-if="permissions.includes('CAN_EDIT_ADMIN_USER')">
                  <div>
                    <v-btn @click="openAdminUserModal(item._id)" class="btn btn-success mr-3">Edit</v-btn>
                  </div>
                </td>
                <td v-if="permissions.includes('CAN_ACTIVE_DEACTIVE_ADMIN_USER')">
                  <div>
                    <v-switch
                      class="mt-0"
                      v-model="item.is_active"
                      @change="activationUser(item)"
                      color="success"
                    ></v-switch>
                  </div>
                </td>
                <td v-if="permissions.includes('CAN_REGENERATE_PASSWORD_ADMIN_USER')">
                  <div>
                    <v-btn
                      @click="getRegeneratePassword(item._id)"
                      class="btn btn-warning mr-3"
                    >Password Regenerate</v-btn>
                  </div>
                </td>
              </tr>
              <tr></tr>
            </tbody>
          </table>
        </div>
      </v-col>

      <admin-user-create
        v-if="openCreateForm"
        @close="closeModal"
        :openCreateForm="openCreateForm"
        :adminUserID="adminUserID"
        :roleList="roleList"
        :permissionResponseData="permissionResponseData"
        @getAdminUserApiCall="getUserData"
      ></admin-user-create>
    </div>
    <div class="text-center">
      <v-pagination
        v-model="page"
        :length="totalPage"
        prev-icon="mdi-menu-left"
        next-icon="mdi-menu-right"
      ></v-pagination>
    </div>
  </div>
</template>
<script>
import config from "@/config.js";
import adminUserCreate from "@/components/modals/adminUserCreateAndEdit.vue";
import loader from "@/components/loader.vue";
import _ from "lodash";
import { mapGetters } from "vuex";
export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {
    adminUserCreate,
    loader
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  data() {
    return {
      page: 1,
      openCreateForm: false,
      userList: [],
      adminUserID: "",
      roleList: [],
      permissionResponseData: {},
      switch2: true,
      showLoader: false,
      totalPage: 0
    };
  },
  mounted() {
    this.getUserData();
    this.getRoles();
    this.getPermission();
  },
  methods: {
    getRegeneratePassword(userId) {
      this.$swal({
        title: "Confirm ",
        text: "Are you sure, you want to regenerate password?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        cancelButtonColor: "#f00",
        type: "warning",
        allowOutsideClick: false
      }).then(setPass => {
        if (setPass.value) {
          let url = `${config.BASE_URL}api/v2/admin/regeneratePassword/${userId}`;
          this.$http.patch(url).then(res => {
            if (res.data.status) {
              this.$swal({
                text: "Regenerate Password Sucessfully",
                icon: "success",
                allowOutsideClick: false,
                showCancelButton: false,
                confirmButtonText: "Ok"
              });
              this.getUserData();
            }
          });
        } else {
          return false;
        }
      });
    },

    // get roll api call
    getRoles() {
      let url = `${config.BASE_URL}api/v2/admin/roles`;
      this.$http.get(url).then(response => {
        if (response.body.status) {
          this.roleList = response.body.data;
        }
      });
    },

    // get Permission api call
    getPermission() {
      let url = `${config.BASE_URL}api/v2/admin/roles/permissions`;
      this.$http.get(url).then(response => {
        if (response.body.status) {
          this.permissionResponseData = response.body.data;
        }
      });
    },

    // get userData api call
    getUserData() {
      this.showLoader = true;
      let url = `${config.BASE_URL}api/v2/admin/users?page=${this.page}&records_per_page=10`;
      this.$http.get(url).then(response => {
        if (response.body.status) {
          this.showLoader = false;
          this.userList = response.body.data.list;
          this.totalPage = response.body.data.count / 10;
          if (response.body.data.count % 10 !== 0)
            this.totalPage = parseInt(JSON.stringify(this.totalPage)) + 1;
        }
      });
    },

    // modal close event
    closeModal() {
      this.openCreateForm = false;
    },

    // modal open event
    openAdminUserModal(data) {
      this.openCreateForm = true;
      this.adminUserID = data;
    },

    // active api call
    activationUser(userInfo) {
      let obj = {
        is_active: userInfo.is_active
      };
      let url = `${config.BASE_URL}api/v2/admin/users/${userInfo._id}`;
      this.$http.patch(url, obj).then(res => {
        if (res.data.status) {
          if (userInfo.is_active) {
            this.$swal({
              text: "User Activated Successfully",
              icon: "success",
              allowOutsideClick: false,
              showCancelButton: false,
              confirmButtonText: "Ok"
            });
          } else {
            this.$swal({
              text: "User De-activated Successfully",
              icon: "success",
              allowOutsideClick: false,
              showCancelButton: false,
              confirmButtonText: "Ok"
            });
          }

          this.getUserData();
        }
      });
    }
  },
  watch: {
    page: function(newVal) {
      this.getUserData();
    }
  }
};
</script>
